import { Link } from "react-router-dom";

const TOOLS = [
  { title: "Capital Gain Calculator", desc: "Upload broker PDF/Excel and get a 5-sheet tax report instantly.", icon: "📈", link: "/tools/capital-gain", tag: "Free" },
  { title: "TDS Calculator", desc: "Enter any expense and get TDS section, rate and threshold using AI.", icon: "🧮", link: "/tools/tds-calculator", tag: "Free" },
  { title: "Bank Statement to Excel", desc: "Convert any bank statement PDF into a structured Excel file.", icon: "🏦", link: "/tools/bank-statement", tag: "Coming Soon" },
  { title: "Property Capital Gain", desc: "Calculate capital gain on property and explore Section 54 savings.", icon: "🏠", link: "/tools/property-gain", tag: "Coming Soon" },
  { title: "TDS on Overseas Payments", desc: "Check DTAA rates vs Income Tax rates for overseas payments.", icon: "🌏", link: "/tools/overseas-tds", tag: "Paid" },
  { title: "Crypto Capital Gain", desc: "Calculate capital gain on cryptocurrencies under Sec 115BBH.", icon: "🪙", link: "/tools/crypto-gain", tag: "Coming Soon" },
];

const TAG_STYLES: {[key: string]: {background: string; color: string}} = {
  "Free":        { background: "#E2F0D9", color: "#375623" },
  "Paid":        { background: "#FFF2CC", color: "#7F6000" },
  "Coming Soon": { background: "#EAE6E0", color: "#5C5C5C" },
};

export default function Home() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>

      <div style={{ background: "linear-gradient(135deg, #2C2C2C 0%, #3A3530 100%)", padding: "64px 32px", textAlign: "center", borderBottom: "3px solid #C9A84C" }}>
        <div style={{ display: "inline-block", background: "rgba(201,168,76,0.15)", border: "1px solid rgba(201,168,76,0.4)", borderRadius: "20px", padding: "5px 16px", fontSize: "13px", color: "#C9A84C", fontWeight: 600, marginBottom: "20px" }}>
          Built by a Chartered Accountant
        </div>
        <h1 style={{ fontSize: "42px", fontWeight: 800, color: "white", marginBottom: "16px", lineHeight: "1.2", maxWidth: "640px", margin: "0 auto 16px" }}>
          Smart Tax Tools for<br /><span style={{ color: "#C9A84C" }}>Chartered Accountants</span>
        </h1>
        <p style={{ fontSize: "16px", color: "#B0ADA8", maxWidth: "520px", margin: "16px auto 32px", lineHeight: "1.7" }}>
          Save hours of manual work. Upload broker reports, calculate capital gains, and generate client-ready tax reports in minutes.
        </p>
        <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
          <a href="/api/auth/google" style={{ background: "#C9A84C", color: "#2C2C2C", padding: "13px 28px", borderRadius: "8px", fontWeight: 700, fontSize: "15px", textDecoration: "none" }}>
            Get Started Free
          </a>
          <Link to="/tools/capital-gain" style={{ background: "transparent", color: "white", border: "1.5px solid rgba(255,255,255,0.3)", padding: "13px 28px", borderRadius: "8px", fontWeight: 600, fontSize: "15px" }}>
            Try Capital Gain Tool
          </Link>
        </div>
      </div>

      <div style={{ background: "var(--card-bg)", borderBottom: "1px solid var(--border)", padding: "20px 32px" }}>
        <div style={{ maxWidth: "900px", margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "16px", textAlign: "center" }}>
          {[["6+", "CA Tools Available"], ["Free", "To Get Started"], ["100%", "Tax Accurate"]].map(([val, label]) => (
            <div key={label}>
              <div style={{ fontSize: "26px", fontWeight: 800, color: "#C9A84C" }}>{val}</div>
              <div style={{ fontSize: "13px", color: "var(--text-muted)", marginTop: "2px" }}>{label}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "48px 32px", flex: 1, width: "100%" }}>
        <h2 style={{ fontSize: "24px", fontWeight: 700, color: "var(--text-primary)", textAlign: "center", marginBottom: "8px" }}>All Tools</h2>
        <p style={{ color: "var(--text-muted)", textAlign: "center", marginBottom: "36px", fontSize: "14px" }}>
          Every tool built with deep knowledge of Indian tax laws
        </p>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "20px" }}>
          {TOOLS.map((tool, idx) => {
            const tagStyle = TAG_STYLES[tool.tag] || TAG_STYLES["Coming Soon"];
            const isComingSoon = tool.tag === "Coming Soon";
            return (
              <Link key={idx} to={tool.link}
                className="tool-card"
                style={{ opacity: isComingSoon ? 0.7 : 1, cursor: isComingSoon ? "default" : "pointer" }}
                onClick={e => { if (isComingSoon) e.preventDefault(); }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "14px" }}>
                  <span style={{ fontSize: "36px", lineHeight: 1 }}>{tool.icon}</span>
                  <span style={{ ...tagStyle, fontSize: "11px", fontWeight: 700, padding: "3px 10px", borderRadius: "10px" }}>
                    {tool.tag}
                  </span>
                </div>
                <h3 style={{ fontSize: "16px", fontWeight: 700, marginBottom: "8px" }}>{tool.title}</h3>
                <p style={{ fontSize: "13px", lineHeight: "1.6" }}>{tool.desc}</p>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
